import Vue from 'vue'
import Router from 'vue-router'
import comm from './comm.js'

Vue.use(Router)
let router = new Router({
  mode: 'hash',
  base: process.env.BASErecord_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: comm.getQueryString('route') || 'record'
      }
    },

    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/gold/GoldRecord'),
      meta: {
        title: '金币记录'
      }
    },
    {
      path: '/comment',
      name: 'comment',
      component: () => import('@/views/comment/Comment'),
      meta: {
        title: '课程评论'
      }
    },
    {
      path: '/commentdetail',
      name: 'commentdetail',
      component: () => import('@/views/comment/CommentDetail'),
      meta: {
        title: '评论详情'
      }
    },
    {
      path: '/permission',
      name: 'permission',
      component: () => import('@/views/permission/Permission'),
      meta: {
        title: '我的权限'
      }
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('@/views/video/Video'),
      meta: {
        title: '视频'
      }
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/test/Test'),
      meta: {
        title: '测试'
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('@/views/detail/Detail'),
      meta: {
        title: '详情'
      }
    },
    {
      path: '/doc/useraggrement',
      name: 'useraggrement',
      component: () => import('@/views/doc/UserAggrement'),
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/doc/useraggrementbig',
      name: 'useraggrementbig',
      component: () => import('@/views/doc/UserAggrementBig'),
      meta: {
        title: '有看投平台大咖服务协议'
      }
    },
    {
      path: '/doc/privacy',
      name: 'privacy',
      component: () => import('@/views/doc/Privacy'),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/doc/mp-privacy',
      name: 'mp-privacy',
      component: () => import('@/views/doc/MpPrivacy'),
      meta: {
        title: '小程序隐私政策'
      }
    },
    {
      path: '/doc/warning',
      name: 'warning',
      component: () => import('@/views/doc/warning'),
      meta: {
        title: '风险提示'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/search/Search'),
      meta: {
        title: ''
      }
    },
    {
      path: '/course-video',
      name: 'course-video',
      component: () => import('@/views/course/Video'),
      meta: {
        title: ''
      }
    },
    {
      path: '/gensee-video',
      name: 'gensee-video',
      component: () => import('@/views/gensee/Video'),
      meta: {
        title: ''
      }
    },
    {
      path: '/live-broadcast',
      name: 'live-broadcast',
      component: () => import('@/views/live/live-broadcast'),
      meta: {
        title: ''
      }
    },
    {
      path: '/transit-page',
      name: 'transit-page',
      component: () => import('@/views/live/transit-page'),
      meta: {
        title: ''
      }
    },
    {
      path: '/course-detail',
      name: 'course-detail',
      component: () => import('@/views/course/CourseDetail'),
      meta: {
        title: '课程详情'
      }
    },
    {
      path: '/course-video-detail',
      name: 'course-video-detail',
      component: () => import('@/views/course/CourseVideoDetail'),
      meta: {
        title: '课程视频详情'
      }
    },
    {
      path: '/exchange-center',
      name: 'exchange-center',
      component: () => import('@/views/exchange/ExchangeCenter'),
      meta: {
        title: '兑换中心'
      }
    },
    {
      path: '/disabled-coupon',
      name: 'disabled-coupon',
      component: () => import('@/views/coupon/DisabledCoupon.vue'),
      meta: {
        title: '无效优惠券'
      }
    },
    {
      path: '/valid-coupon',
      name: 'valid-coupon',
      component: () => import('@/views/coupon/ValidCoupon.vue'),
      meta: {
        title: '可用优惠券'
      }
    },
    {
      path: '/unlock-coupon',
      name: 'unlock-coupon',
      component: () => import('@/views/coupon/UnlockCoupon.vue'),
      meta: {
        title: '解锁券'
      }
    },
    {
      path: '/unlock-rule',
      name: 'unlock-rule',
      component: () => import('@/views/coupon/UnlockRule.vue'),
      meta: {
        title: '解锁规则'
      }
    },
    {
      path: '/vote-detail',
      name: 'vote-detail',
      component: () => import('@/views/vote/vote-detail'),
      meta: {
        title: '人气嘉宾票选'
      }
    },
    {
      path: '/vote-rank',
      name: 'vote-rank',
      component: () => import('@/views/vote/vote-rank'),
      meta: {
        title: '人气嘉宾票选'
      }
    },
    {
      path: '/ticket-sales',
      name: 'ticket-sales',
      component: () => import('@/views/Activity/ticketSales/ticketSales'),
      meta: {
        title: '线下见面会'
      }
    },
    {
      path: '/unlock-bag',
      name: 'unlock-bag',
      component: () => import('@/views/unlock/UnlockBag.vue'),
      meta: {
        title: '解锁课程'
      }
    },
    {
      path: '/unlock-course',
      name: 'unlock-course',
      component: () => import('@/views/unlock/UnlockCourse.vue'),
      meta: {
        title: '解锁课程'
      }
    },
    {
      path: '/unlock-gold',
      name: 'unlock-gold',
      component: () => import('@/views/unlock/UnlockGold.vue'),
      meta: {
        title: '解锁点金'
      }
    },
    {
      path: '/privacy/index',
      name: 'privacy-index',
      component: () => import('@/views/privacy/index.vue'),
      meta: {
        title: '有看投隐私政策'
      }
    },
    {
      path: '/privacy/policysummary',
      name: 'policysummary',
      component: () => import('@/views/privacy/policysummary.vue'),
      meta: {
        title: '有看投隐私政策摘要'
      }
    },
    {
      path: '/privacy/personal',
      name: 'privacy-personal',
      component: () => import('@/views/privacy/personal.vue'),
      meta: {
        title: '个人信息收集清单'
      }
    },
    {
      path: '/privacy/sdklist',
      name: 'privacy-sdklist',
      component: () => import('@/views/privacy/sdklist.vue'),
      meta: {
        title: '第三方信息共享清单'
      }
    },
  ]
})
router.afterEach(route => {
  let documentTitle = ''

  route.matched.forEach(path => {
    if (path.meta.title) {
      documentTitle = path.meta.title
    }
  })

  if (documentTitle) {
    document.title = documentTitle
    // 直接修改title，ios设备不能自动刷新，需要调用客户端的方法进行更新
    if (window.goods && window.goods.updateTitle) {
      window.goods.updateTitle({ title: documentTitle })
    }
  }
})

export default router
